import { render } from "./BehaviorLegend.vue?vue&type=template&id=8a1a8dee"
import script from "./BehaviorLegend.vue?vue&type=script&lang=js"
export * from "./BehaviorLegend.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__